import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-h-primary-50 py-10" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "flex flex-col gap-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_General = _resolveComponent("General")!
  const _component_Objectives = _resolveComponent("Objectives")!
  const _component_Quiz = _resolveComponent("Quiz")!
  const _component_Students = _resolveComponent("Students")!
  const _component_AttentionLogs = _resolveComponent("AttentionLogs")!
  const _component_GridLayout = _resolveComponent("GridLayout")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_GridLayout, {
        list: _ctx.setlist(),
        banner: _ctx.banner,
        onOnScroll: _ctx.scrollMeTo
      }, {
        content: _withCtx(() => [
          (_ctx.loader)
            ? (_openBlock(), _createBlock(_component_Loader, {
                key: 0,
                loader: _ctx.loader
              }, null, 8, ["loader"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              ref: _ctx.enumLinks.general
            }, [
              _createVNode(_component_General)
            ], 512),
            _createElementVNode("div", {
              ref: _ctx.enumLinks.objectives
            }, [
              _createVNode(_component_Objectives)
            ], 512),
            _createElementVNode("div", {
              ref: _ctx.enumLinks.quiz
            }, [
              _createVNode(_component_Quiz)
            ], 512),
            _createElementVNode("div", {
              ref: _ctx.enumLinks.students
            }, [
              _createVNode(_component_Students)
            ], 512),
            (_ctx.isAdaptive)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref: _ctx.enumLinks.attentionLogs
                }, [
                  _createVNode(_component_AttentionLogs)
                ], 512))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !_ctx.loader]
          ])
        ]),
        _: 1
      }, 8, ["list", "banner", "onOnScroll"])
    ])
  ]))
}